import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ActionCreator from "../ActionCreator";
import Selectors from "../Selectors";
import * as Icon from "./Icon";
import * as Widget from "./Widget2";
import DialogContent from "../../content/WelcomeDialogContent";
import { FacebookLoginButton, GoogleLoginButton } from "./SocialLoginButtons";
import RuntimeGlobalVariables from "../RuntimeGlobalVarables";
import { StaticFluidImage } from "./StaticImage/HeCafe";

function getDialogStorageKey({ profile, content }) {
  return `has_shown_welcome_dialog-${
    profile ? `AUTH_USER_${profile.id}` : "GUEST_USER"
  }-${content.id}`;
}

function hasContentShownBefore({ profile }) {
  const Content = profile ? DialogContent.AUTH_USER : DialogContent.GUEST_USER;
  const key = getDialogStorageKey({ profile, content: Content });
  return window.localStorage.getItem(key);
}

class WelcomeDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      defaultPath: "/"
    };
  }

  componentDidMount() {
    let { resultPath = "/" } = this.props;
    this.setState({ defaultPath: resultPath });

    let { isAppDoneAutoLoginProcess, profile } = this.props;
    if (
      isAppDoneAutoLoginProcess &&
      !RuntimeGlobalVariables.isWelcomeDialogShown &&
      !hasContentShownBefore({ profile })
    ) {
      this.setState({ open: true });
    }
    this._cleanOutdatedLocalStorageKey();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      !prevProps.isAppDoneAutoLoginProcess &&
      this.props.isAppDoneAutoLoginProcess &&
      !RuntimeGlobalVariables.isWelcomeDialogShown &&
      !hasContentShownBefore({ profile: this.props.profile })
    ) {
      this.setState({ open: true });
    }
  }

  render() {
    let { profile, isAppDoneAutoLoginProcess } = this.props;
    let { open, defaultPath } = this.state;
    const Content = profile
      ? DialogContent.AUTH_USER
      : DialogContent.GUEST_USER;

    if (!Content.enabled) {
      return null;
    }
    return (
      <Dialog open={open} className={`${open ? "active" : ""}`}>
        <div className="backdrop" onClick={this._onClose} />
        {open && (
          <div className="container" onClick={e => e.stopPropagation()}>
            <div className="close" onClick={this._onClose}>
              <Icon.Close color="#575757" size={26} />
            </div>
            <div className="content">
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center"
                }}
              >
                {Content.image && (
                  <StaticFluidImage
                    path={Content.image}
                    style={{
                      marginBottom: 5,
                      maxWidth: "100%",
                      width: "100%",
                      height: "auto"
                    }}
                  />
                )}
                {Content.title && <div className="title">{Content.title}</div>}
                {Content.detail && (
                  <div className="detail">{Content.detail}</div>
                )}
                {!profile && (
                  <Widget.Row
                    css={`
                      margin-top: 10px;
                      width: 100%;
                      @media screen and (max-width: 550px) {
                        flex-direction: column;
                      }
                    `}
                    justify="center"
                    align="center"
                  >
                    <FacebookLoginButton
                      pathname={defaultPath}
                      css={`
                        min-width: 160px;
                        margin-right: 30px;
                        @media screen and (max-width: 550px) {
                          margin: 10px 0px 0px 0px;
                        }
                      `}
                      location="WelcomeDialog"
                    />
                    <GoogleLoginButton
                      pathname={defaultPath}
                      css={`
                        min-width: 160px;
                        @media screen and (max-width: 550px) {
                          margin: 10px 0px 0px 0px;
                        }
                      `}
                      location="WelcomeDialog"
                    />
                  </Widget.Row>
                )}
              </div>
            </div>
          </div>
        )}
      </Dialog>
    );
  }

  _onClose = () => {
    let { profile } = this.props;
    const Content = profile
      ? DialogContent.AUTH_USER
      : DialogContent.GUEST_USER;

    RuntimeGlobalVariables.isWelcomeDialogShown = true;
    if (Content.show_once) {
      const key = getDialogStorageKey({ profile, content: Content });
      window.localStorage.setItem(`${key}`, "true");
    }
    this.setState({ open: false });
  };

  _cleanOutdatedLocalStorageKey = () => {
    try {
      let data = window.localStorage;
      let dialogKeys = Object.keys(data).filter(
        e => e.indexOf("has_shown_welcome_dialog") === 0
      );
      let currentActiveGuestUserReg = new RegExp(
        `^has_shown_welcome_dialog-GUEST_USER-${DialogContent.GUEST_USER.id}$`
      );
      let currentActiveAuthUserReg = new RegExp(
        `^has_shown_welcome_dialog-AUTH_USER_.+-${DialogContent.AUTH_USER.id}$`
      );
      for (let key of dialogKeys) {
        if (
          !currentActiveGuestUserReg.test(key) &&
          !currentActiveAuthUserReg.test(key)
        ) {
          console.log("item to be remove:", key);
          window.localStorage.removeItem(key);
        }
      }
    } catch (err) {
      //
    }
  };
}

let Dialog = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  display: flex;

  transform: translateX(-100vw);
  transition: 0s ease-in transform 0.5s;

  &.active {
    transform: translateX(0);
    transition: 0s ease-in transform 0s;
  }

  & .backdrop {
    background-color: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: ${props => (props.open ? 1 : 0)};
    transition: 0.2s ease-in opacity;
  }

  & .container {
    background-color: #fff;
    width: 90%;
    max-width: 557px;
    min-height: 200px;
    max-height: calc(100% - 60px);
    border-radius: 59px;
    z-index: 1001;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;

    & > .close {
      cursor: pointer;
      position: absolute;
      top: 20px;
      right: 20px;
    }

    & > .content {
      overflow: auto;
      max-width: 477px;
      width: 100%;

      & .title {
        margin-bottom: 30px;
        white-space: pre-wrap;
        letter-spacing: 1.4px;
        line-height: 30px;
        text-align: center;
        font-size: 24px;
        color: #553617;
      }

      & .detail {
        white-space: pre-wrap;
        line-height: 24px;
        font-size: 16px;
        color: #755b41;
      }
    }

    & .button-bar {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 30px;
      max-width: 420px;
      width: 100%;

      & > .hint {
        flex: 1;
        margin-right: 5px;
        font-size: 14px;
        color: red;
      }

      & > button {
        border: 1px solid #bd9f84;
        background: #ffffff;
        text-align: center;
        cursor: pointer;
        min-width: 116px;
        min-height: 40px;

        font-size: 16px;
        color: #bd9f84;

        :focus {
          outline: none;
        }
      }
    }

    @media screen and (max-width: 700px) {
      min-width: initial;
      padding: 40px 60px;
    }

    @media screen and (max-width: 550px) {
      padding: 25px;

      & > .content {
        & .title {
          margin-bottom: 10px;
        }
      }
    }
  }
`;

export default connect(
  (state, ownProps) => ({
    profile: Selectors.getLoginUser(state),
    isAppDoneAutoLoginProcess: Selectors.getIsAppDoneAutoLoginState(state)
  }),
  ActionCreator
)(WelcomeDialog);
